import { ComponentProps, ComponentType } from 'react';

export const ModuleWithProp = <T extends ComponentType<any>>(Component: T, customProps: ComponentProps<T>) => {
  return (props: any) => <Component {...props} {...customProps} />;
};
